module.exports = __webpack_public_path__ + "img/Bluetooth.3e318042.png";